module.exports = __webpack_public_path__ + "img/cookie_option.svg";